module.exports = __webpack_public_path__ + "static/media/golden_dragon.054d3fd8.webp";